import { render } from "./PhysicalFAQ.vue?vue&type=template&id=82767016&scoped=true"
import script from "./PhysicalFAQ.vue?vue&type=script&lang=js"
export * from "./PhysicalFAQ.vue?vue&type=script&lang=js"

import "./PhysicalFAQ.vue?vue&type=style&index=0&id=82767016&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82767016"]])

export default __exports__